import monthlyIncome from './monthlyIncome'
import monthlySavings from './monthlySavings'
import monthlyExpenses from './monthlyExpenses'
import annualExpenses from './annualExpenses'

export default (form) => (
  monthlyIncome(form)
    - monthlySavings(form)
    - monthlyExpenses(form)
    - annualExpenses(form) / 12
)
